import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
// import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import MeetingRoomRoundedIcon from '@mui/icons-material/MeetingRoomRounded';

export const HOME = "/";
export const LOGIN = "/login";
export const CHANGE_PASSWORD = "/cambiar-contrasena";
export const NOT_ALLOWED = "/not-allowed";
export const DEMO = "/demo";

export const ADMIN = "/admin";
export const TIMBRADOS = `${ADMIN}/timbrados`;
export const TIMBRADO_NEW = `${TIMBRADOS}/new`;
export const TIMBRADO_DETAIL = `${TIMBRADOS}/:id`;

export const CLIENTES = `${ADMIN}/clientes`;
export const CLIENTE_NEW = `${CLIENTES}/new`;
export const CLIENTE_DETAIL = `${CLIENTES}/:id`;

export const PROFILE = "/profile";

export const USUARIOS = `${ADMIN}/usuarios`;
export const USUARIO_NEW = `${USUARIOS}/new`;
export const USUARIO_DETAIL = `${USUARIOS}/:id`;

export const ITEMS = `${ADMIN}/items`;
export const ITEM_NEW = `${ITEMS}/new`;
export const ITEM_DETAIL = `${ITEMS}/:id`;

export const ROLES = `${ADMIN}/roles`;
export const ROLES_NEW = `${ROLES}/new`;
export const ROLES_DETAIL = `${ROLES}/:id`;

export const EMPRESAS = `${ADMIN}/empresas`;
export const EMPRESA_NEW = `${EMPRESAS}/new`;
export const EMPRESA_DETAIL = `${EMPRESAS}/:id`;

export const VENTA = "/ventas";
export const VENTA_NEW = `${VENTA}/new`;
export const VENTA_DETAIL = `${VENTA}/:id`;

export const DOCUMENTOS = "/documentos";
export const DOCUMENTO_NEW = `${DOCUMENTOS}/new`;
export const DOCUMENTO_DETAIL = `${DOCUMENTOS}/:id`;

export const RECIBOS = "/recibos";
export const RECIBO_NEW = `${RECIBOS}/new`;
export const RECIBO_DETAIL = `${RECIBOS}/:reciboId`;

export const EGRESOS = "/egresos";
export const EGRESO_NEW = `${EGRESOS}/new`;
export const EGRESO_EDIT = `${EGRESOS}/:id/edit`;
export const EGRESO_DETAIL = `${EGRESOS}/:id`;

export const STOCK = "/stock";

export const COMPRAS = `${STOCK}/compras`;
export const COMPRA_NEW = `${COMPRAS}/new`;
export const COMPRA_EDIT = `${COMPRAS}/:id/edit`;
export const COMPRA_DETAIL = `${COMPRAS}/:id`;

export const PRODUCTOS = `${STOCK}/productos`;
export const PRODUCTO_NEW = `${PRODUCTOS}/new`;
export const PRODUCTO_DETAIL = `${PRODUCTOS}/:id`;

export const MOVIMIENTOS_STOCK = `${STOCK}/movimientos`;
export const MOVIMIENTO_STOCK_NEW = `${MOVIMIENTOS_STOCK}/new`;
export const MOVIMIENTO_STOCK_DETAIL = `${MOVIMIENTOS_STOCK}/:id`;

export const DOCUMENTOS_PROGRAMADOS = "/documentos-programados";
export const DOCUMENTO_PROGRAMADO_NEW = `${DOCUMENTOS_PROGRAMADOS}/new`;

export const CERTIFICADOS = `${ADMIN}/certificados`;
export const CERTIFICADO_NEW = `${CERTIFICADOS}/new`;
export const CERTIFICADO_DETAIL = `${CERTIFICADOS}/:id`;

export const MI_EMPRESA = "/mi-empresa";

export const RECURSOS = "/recursos";
export const TIPOS_RECURSO = `${RECURSOS}/tipos`;
export const TIPO_RECURSO_NEW = `${TIPOS_RECURSO}/new`;
export const TIPO_RECURSO_DETAIL = `${TIPOS_RECURSO}/:id`;

export const RECURSOS_LIST = `${RECURSOS}/lista`;
export const RECURSO_NEW = `${RECURSOS_LIST}/new`;
export const RECURSO_DETAIL = `${RECURSOS_LIST}/:id`;

export const TARIFAS = `${RECURSOS}/tarifas`;
export const TARIFA_NEW = `${TARIFAS}/new`;
export const TARIFA_DETAIL = `${TARIFAS}/:id`;

export const USOS_RECURSO = `${RECURSOS}/usos`;
export const USO_RECURSO_DETAIL = `${USOS_RECURSO}/:id`;

export const TABLERO_RECURSOS = `${RECURSOS}/tablero`;


export const NAV_CONFIG = [
  {
    label: "Inicio",
    icon: HomeRoundedIcon,
    linkTo: HOME,
  },
  {
    label: "Documentos",
    icon: ReceiptIcon,
    linkTo: DOCUMENTOS,
    permiso: "VER_DOCUMENTOS",
  },
  {
    label: "Recibos",
    icon: ReceiptLongIcon,
    linkTo: RECIBOS,
    permiso: "VER_DOCUMENTOS",
  },
  /*
  {
    label: "Egresos",
    icon: RequestQuoteIcon,
    linkTo: EGRESOS,
    permiso: "VER_DOCUMENTOS",
  },
  */
  {
    label: "Programados",
    icon: EventRepeatIcon,
    linkTo: DOCUMENTOS_PROGRAMADOS,
    permiso: "VER_DOCUMENTOS",
  },
  {
    label: "Recursos",
    icon: MeetingRoomRoundedIcon,
    permiso: "VER_RECURSOS",
    empresaField: "recursosEnabled",
    subNav: [
      /*
      {
        label: "Tablero",
        linkTo: TABLERO_RECURSOS,
        permiso: "VER_RECURSOS",
      },*/
      {
        label: "Uso de Recursos",
        linkTo: USOS_RECURSO,
        permiso: "VER_USOS_RECURSOS",
      },
      {
        label: "Tipos de Recurso",
        linkTo: TIPOS_RECURSO,
        permiso: "VER_TIPOS_RECURSOS",
      },
      {
        label: "Recursos",
        linkTo: RECURSOS_LIST,
        permiso: "VER_RECURSO",
      },
      {
        label: "Tarifas",
        linkTo: TARIFAS,
        permiso: "VER_TARIFAS_RECURSOS",
      },
    ],
  },
  {
    label: "Stock",
    icon: Inventory2OutlinedIcon,
    permiso: "VER_STOCK",
    subNav: [
      {
        label: "Compras",
        linkTo: COMPRAS,
        permiso: "VER_STOCK",
      },
      {
        label: "Productos",
        linkTo: PRODUCTOS,
        permiso: "VER_STOCK",
      },
      {
        label: "Movimientos",
        linkTo: MOVIMIENTOS_STOCK,
        permiso: "VER_STOCK",
        empresaField: "stockEnabled",
      },
    ],
  },
  {
    label: "Admin",
    icon: WorkOutlineOutlinedIcon,
    permiso: "VER_ADMIN",
    subNav: [
      {
        label: "Timbrados",
        linkTo: TIMBRADOS,
        permiso: "VER_TIMBRADOS",
      },
      {
        label: "Clientes",
        linkTo: CLIENTES,
        permiso: "VER_CLIENTES",
      },
      {
        label: "Items",
        linkTo: ITEMS,
        permiso: "VER_ITEMS",
      },
      {
        label: "Usuarios",
        linkTo: USUARIOS,
        permiso: "VER_USUARIOS",
      },
      {
        label: "Roles",
        linkTo: ROLES,
        permiso: "VER_ROLES",
      },
      {
        label: "Empresas",
        linkTo: EMPRESAS,
        permiso: "VER_EMPRESAS",
      },
      {
        label: "Certificados",
        linkTo: CERTIFICADOS,
        permiso: "VER_CERTIFICADOS",
      },
    ],
  },
];
